import React, { useEffect, useState } from 'react';

import { Stripe, loadStripe } from '@stripe/stripe-js';

import config from '../envConfig';
import {
  useLazyGetUserChatsApiQuery,
  useLazyGetUserUnreadMessagesApiQuery,
} from '../redux/api/chatsApi';
import { IChatMessage } from '../types/interfaces/chat-message';
import { useWebSocket } from './WebSocketContext';

interface IGlobalContextValue {
  unreadMessages: IChatMessage[];
  stripePromise: Promise<Stripe | null> | null;
}

const GlobalContext = React.createContext<IGlobalContextValue | undefined>(
  undefined,
);

interface IGlobalProviderProps {
  children: React.ReactNode;
}

function GlobalProvider(props: IGlobalProviderProps) {
  const { addListener, removeListener } = useWebSocket();
  const [listenedChatIds, setListenedChatIds] = useState<string[]>([]);
  const [unreadMessagesState, setUnreadMessagesState] = useState<
    IChatMessage[]
  >([]);
  const [getUserChats, { data: chats }] = useLazyGetUserChatsApiQuery();
  const [
    getUserUnreadMessages,
    { data: unreadMessages, isFetching: isFetchingMessages },
  ] = useLazyGetUserUnreadMessagesApiQuery();
  const [stripePromise, setStripePromise] =
    useState<Promise<Stripe | null> | null>(null);

  useEffect(() => {
    const isLocalEnv = config.environment === 'local';
    const stripeLoadOptions = isLocalEnv
      ? undefined
      : {
          developerTools: {
            assistant: {
              enabled: false,
            },
          },
        };

    setStripePromise(
      loadStripe(config.stripePublishableKey, stripeLoadOptions).catch((e) => {
        console.log('[Stripe loading error]: ', e);
        return null;
      }),
    );
  }, []);

  useEffect(() => {
    if (!isFetchingMessages) setUnreadMessagesState(unreadMessages || []);
  }, [isFetchingMessages, unreadMessages]);

  // useEffect(() => {
  //   // addListener("newChat", "newChat", () => {
  //   //   dispatch(resetChatsApiState());
  //   // });
  //   // return () => {
  //   //   removeListener("newChat");
  //   // }
  // }, []);
  //
  // useEffect(() => {
  //   if (!chats) return;
  //
  //   let newChatIds = [];
  //
  //   chats
  //     ?.filter((chat) => !listenedChatIds.find((id) => id === chat.id))
  //     .forEach((chat) => {
  //       addListener(
  //         `gcChatMessage-${chat.id}`,
  //         `chatMessage-${chat.id}`,
  //         (message) => {
  //           if (message.userId !== user.id)
  //             setUnreadMessagesState((prev) => ({
  //               ...prev,
  //               [chat.id]: [...(prev[chat.id] || []), message],
  //             }));
  //         },
  //       );
  //
  //       newChatIds.push(chat.id);
  //     });
  //
  //   setListenedChatIds((prev) => ({ ...prev, ...newChatIds }));
  //
  //   return () => {
  //     chats.forEach((chat) => removeListener(`gcChatMessage-${chat.id}`));
  //   };
  // }, [chats]);

  return (
    <GlobalContext.Provider
      value={{
        unreadMessages: unreadMessagesState,
        stripePromise,
      }}>
      {props.children}
    </GlobalContext.Provider>
  );
}

function useGlobal() {
  const context = React.useContext(GlobalContext);
  if (context === undefined) {
    throw new Error('useGlobal must be used within GlobalProvider');
  }

  return context;
}

export { useGlobal, GlobalProvider };
